import { render, staticRenderFns } from "./GroupBookingDetail.vue?vue&type=template&id=fb429cb0&scoped=true&"
import script from "./GroupBookingDetail.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingDetail.vue?vue&type=style&index=0&id=fb429cb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb429cb0",
  null
  
)

export default component.exports